define('editor/edit/contexts/index',['durandal/app', 'knockout'], function (app, ko) {
    var viewmodel = function () {
        var self = this;

        self.contexts = ko.observableArray([
            {
                name: ko.observable('layers'),
                active: ko.observable(false),
                model: 'editor/edit/layers/index'
            },
            {
                name: ko.observable('settings'),
                active: ko.observable(false),
                model: 'editor/edit/contexts/settings'
            },
            {
                name: ko.observable('export'),
                active: ko.observable(false),
                model: 'editor/edit/contexts/export'
            },
            {
                name: ko.observable('preview'),
                active: ko.observable(false),
                model: 'editor/edit/contexts/preview'
            }
        ]);
        self.content = ko.observable();

        self.activate = function (editorMap) {
            var defaultContext = self.contexts()[0];
            
            self.editorMap = editorMap;
            self.activateContext(defaultContext);
        };

        self.activateContext = function (model) {
            var contextName = model.name(),
                contextToActivate = self.findContextByName(contextName),
                contextsLen = self.contexts().length;
            
            if (contextToActivate.active()) {
                return;
            }

            if (self.editorMap.readOnly && (contextName === 'settings' || contextName === 'export')) {
                app.showMessage('You do not have permission to edit this map.', 'Cannot open ' + contextName);
                return;
            } 

            for (var i = 0; i < contextsLen; i++) {
                var context = self.contexts()[i];

                context.active(false);
            }
            
            self.activateModelForContext(contextToActivate);
        };

        self.findContextByName = function (name) {
            var contextsLen = self.contexts().length,
                found = null;

            for (var i = 0; i < contextsLen; i++) {
                var context = self.contexts()[i];

                if (context.name() === name) {
                    found = context;
                    break;
                }
            }

            return found;
        };

        self.activateModelForContext = function (contextToActivate) {
            contextToActivate.active(true);

            if (self.content() && self.content().model.deactivate) {
                self.content().model.deactivate();
            }
            
            self.content({ model: contextToActivate.model, activationData: [self.editorMap] });
        };
    };

    return viewmodel;
});

